import { render, staticRenderFns } from "./UrgencyProviders.vue?vue&type=template&id=bc5d1c74&scoped=true&lang=pug"
import script from "./UrgencyProviders.vue?vue&type=script&lang=js"
export * from "./UrgencyProviders.vue?vue&type=script&lang=js"
import style0 from "./UrgencyProviders.vue?vue&type=style&index=0&id=bc5d1c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5d1c74",
  null
  
)

export default component.exports